import React from 'react';
import { ExternalLink } from '../../components';
import { FormattedMessage } from '../../util/reactIntl';
import css from './ContactPage.module.css';
import messIcon from './messenger-icon.png';
import config from '../../config';

const MessengerSection = () => {
  const { siteMessengerPage } = config;

  return (
    <div className={css.messengerSection}>
      <h2 className={css.contactUs}>
        <FormattedMessage id="ContactPage.contactUs" />
      </h2>
      <p>
        <FormattedMessage
          id="ContactPage.messengerDescription"
          values={{
            link: (
              <ExternalLink className={css.link} href={siteMessengerPage}>
                <FormattedMessage id="ContactPage.clicking" />
              </ExternalLink>
            ),
          }}
        />
      </p>
      <ExternalLink href={siteMessengerPage}>
        <img className={css.messIcon} src={messIcon} alt="Hubista Facebook Messenger" />
      </ExternalLink>
    </div>
  );
};

export default MessengerSection;
